import ChangeSelfPwdForm from '@/views/common/account/change-self-pwd/change-self-pwd-form.vue';
export const useChangeSelfPwdModal = () => {
  const {
    openEditor
  } = useComponentModal();
  const showChangeSelfPwdModal = async (title = '修改密码') => {
    return openEditor(title, ChangeSelfPwdForm, {}, {
      width: '40%',
      showMaximize: false,
      showMinimize: false
    });
  };
  return {
    showChangeSelfPwdModal
  };
};